var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-20",
    "data-name": "50_Kids_Icons-20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M80,40A40,40,0,1,1,40,0,40,40,0,0,1,80,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4391",
    "data-name": "Group 4391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4390",
    "data-name": "Group 4390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4389",
    "data-name": "Group 4389",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4381",
    "data-name": "Group 4381",
    transform: "translate(13.795 34.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M91.045,226.429c2.272-2.79,6.444-4.575,9.624-6.034,1.735-.8,5.669-1.957,7.5-1.036,2.666,1.337-3.175,3.455-3.945,3.845-3.354,1.7-5.056,5.441-5.388,9.122-.36,3.988,1.023,7.112,3.785,10.006a10.116,10.116,0,0,1-10.893-.834C87.421,238,87.112,231.257,91.045,226.429Z",
    transform: "translate(-88.286 -219.02)",
    fill: "#ebab2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4380",
    "data-name": "Group 4380",
    transform: "translate(32.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M316.106,226.429c-2.272-2.79-6.444-4.575-9.624-6.034-1.735-.8-5.669-1.957-7.5-1.036-2.666,1.337,3.175,3.455,3.945,3.845,3.354,1.7,5.056,5.441,5.388,9.122.36,3.988-1.023,7.112-3.785,10.006a10.117,10.117,0,0,0,10.893-.834C319.731,238,320.039,231.257,316.106,226.429Z",
    transform: "translate(-298.285 -219.02)",
    fill: "#ebab2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4382",
    "data-name": "Group 4382",
    transform: "translate(23.917 37.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M159.79,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S158.765,244.065,159.79,246.493Z",
    transform: "translate(-153.072 -242.885)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M326.844,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S327.869,244.065,326.844,246.492Z",
    transform: "translate(-299.259 -242.885)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 17.969,
    cy: 16.449,
    rx: 17.969,
    ry: 16.449,
    transform: "translate(23.1 13.485)",
    fill: "#ffc34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M135.242,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-65.172 -326.964)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M233.822,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.157 -214.962)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4383",
    "data-name": "Group 4383",
    transform: "translate(26.26 18.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M197.682,141.985a15.048,15.048,0,0,1-14.807,15.289h0a15.049,15.049,0,0,1-14.812-15.289v-8.813a15.055,15.055,0,0,1,14.812-15.287h0a15.054,15.054,0,0,1,14.807,15.287Z",
    transform: "translate(-168.063 -117.885)",
    fill: "#ffdec2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4384",
    "data-name": "Group 4384",
    transform: "translate(34.39 41.491)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    fill: "#572020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(10.263)",
    fill: "#572020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4386",
    "data-name": "Group 4386",
    transform: "translate(25.358 18.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M178,115.709c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l1.561-13.238h24.037l1.564,13.239a18.051,18.051,0,0,0,2.13-8.566C193.716,123.333,186.682,115.709,178,115.709Z",
    transform: "translate(-162.294 -115.709)",
    fill: "#ffc34a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M251.273,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,251.273,279.542Z",
    transform: "translate(-207.989 -235.864)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M135.233,425.067c0-8-2.995-15.753-6.652-17.229L116.2,402.849a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.172 -339.904)",
    fill: "#eb7fa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M150,190.008a10.433,10.433,0,0,0,5.065,4.1l14.429,5.5a10.483,10.483,0,0,0,13.53-6.06l1.351-3.542Z",
    transform: "translate(-126.563 -160.319)",
    fill: "#ffc34a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4388",
    "data-name": "Group 4388",
    transform: "translate(35.938 48.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4387",
    "data-name": "Group 4387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M230,307.442c.1,3.336,2.457,6.007,5.357,6.007s5.26-2.671,5.356-6.006a12.159,12.159,0,0,1-10.713,0Z",
    transform: "translate(-230 -307.442)",
    fill: "#db4646"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.c8c85519d2d0cca723a01d7382a96b82.svg";
export { ForwardRef as ReactComponent };